<template>
<div id="echart_trend">
  <form>
    <p v-show="leakageLog.length!==0">{{$t("watersystem.detection-history")}}</p>
    <p v-show="leakageLog.length===0">{{$t('watersystem.no-water-leak-history')}}</p>
    <v-layout row justify-space-between class="pl-5 pr-5">
      <v-flex xs2>
        <v-btn
          small outline
          type="button"
          v-on:click="reload"
          :disabled="reloading||autoReload"
        >
          {{$t("chart.button-reload")}}
        </v-btn>
      </v-flex>
    </v-layout>
    <table class="mt-3 leakage-log-table" v-show="leakageLog.length!==0">
    <tr v-for="log in leakageLog" :class=getClassName(log.state)>
      <td v-if="log.state==1">{{$t('watersystem.leakage-alert')}}</td>
      <td v-if="log.state==0">{{$t('watersystem.return-to-normal')}}</td>
      <td>{{log.timestamp}}</td>
    </tr>
    </table>
  </form>
</div>
</template>

<script>
import Graph from '@/utils/graph.js'
import utils from '@/utils/utils.js'

export default {
  name: 'LeakageLog',
  props: {
    // 親のテンプレートで指定した場合はそれを使う
    // 未指定の場合はUUIDユニークな値を自ら生成する
    id: {
      type: String,
      default () {
        return 'chart_' + utils.generateUuid()
      }
    },
    // グラフに描画する対象のデータID（必須）
    dataId: {
      type: String,
      required: true
    },
    // グラフ描画時のタイムゾーン設定
    timezone: {
      type: String,
      default: 'UTC'
    },
    activeTab: {
      type: String,
      default: ''
    },
    properties: {
      type: String,
      default: 'LeakageLog'
    },
    color: {
      type: String,
      default: 'blue'
    },
    details: {
      type: Array,
      default: {}
    },
    selectEditPort: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      // 親側で切り替えられると困るので、ここで保持しておく
      // リロード中フラグ
      reloading: false,
      autoReload: false,
      setIntervalId: null,

      // ブラウザのロケール情報
      locale: this.$store.getters.locale,
      dateOptions: [],
      // サービスのコードリスト
      serviceCodes: this.$store.getters.serviceList.codes,
      leakageLog: []
    }
  },
  computed: {
    // API呼び出し時に渡す
    params () {
      return {
        dataId: this.dataId,
        sort: 'asc', // 固定
        timezone: this.timezone,
        from: this.from,
        to: this.to
      }
    }
  },
  methods: {
    // データ取得＆グラフ描画処理
    reload () {
      var self = this
      var params = self.params
      self.dateOptions = {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: false,
        timeZone: self.timezone
      }
      // API呼び出し
      self.graph.leakageLog(params)
        .then((data) => {
          // しきい値取得
          var alertRate = 0
          self.details.forEach(function (param) {
            if (param.portNumber === self.selectEditPort) {
              alertRate = param.alertRate
            }
          })
          var firstDataFlag = false
          var firstNomalFlag = false
          var res = []
          data.data.forEach(function (log) {
            if (alertRate > log.Rate && !firstNomalFlag) {
              res.unshift({
                state: 1,
                timestamp: utils.dateFormatter(self.locale, log.Timestamp * 1000, self.dateOptions)
              })
              firstDataFlag = true
              firstNomalFlag = true
            } else if (firstDataFlag && alertRate < log.Rate && firstNomalFlag) {
              firstNomalFlag = false
              res.unshift({
                state: 0,
                timestamp: utils.dateFormatter(self.locale, log.Timestamp * 1000, self.dateOptions)
              })
            }
          })
          this.emitEarliestTimestamp(data.data)
          this.leakageLog = res
        })
      // メタデータの更新のためにgetFiltrationSystemを発火
      this.$emit('child-action')
    },
    emitEarliestTimestamp (data) {
      if (data.length !== 0) {
        this.$emit('emit-earliest-timestamp', data[0].Timestamp)
      }
    },
    getClassName (state) {
      if (state === 1) {
        return 'leakage-alert'
      } else {
        return 'leakage-normal'
      }
    }
  },

  watch: {
    dataId () {
      this.reload()
    },
    properties () {
      this.reload()
    },
    timezone () {
      this.reload()
    },
    activeTab () {
      if (this.activeTab === this.serviceCodes[4]) {
        this.reload()
      }
    },
    autoReload () {
      // 自動リロードの有効化
      if (this.autoReload === true) {
        this.setIntervalId = setInterval(() => {
          this.reload()
        }, 2000)
      } else {
        clearInterval(this.setIntervalId)
      }
    }
  },
  created () {
    this.graph = new Graph({
      token: 'MyToken'
    })
  },

  mounted () {
    // 初回のデータロード
    this.reload()
  }
}
</script>
<style>

table.leakage-log-table{
  margin-left: 1em;
  border: 1px solid #CCC;
  width: 100%;
}
table.leakage-log-table td{
  border: 1px solid #CCC;
}

tr.leakage-alert {
  background-color: #FDD;
}

tr.leakage-normal {
  background-color: #EFF;
}
</style>



// WEBPACK FOOTER //
// LeakageLog.vue?028f54c0